import {initializeApp} from "firebase/app";
import {getFunctions, httpsCallable, connectFunctionsEmulator} from "firebase/functions";
import {getAnalytics} from "firebase/analytics";
import {RequestData, ResponseData} from "@functions/models";

const firebaseConfig = {
  apiKey: "AIzaSyDz9eJG1unLfK6VRdXo7s8wc_e3lzLNDiA",
  authDomain: "pb-marina.firebaseapp.com",
  projectId: "pb-marina",
  storageBucket: "pb-marina.appspot.com",
  messagingSenderId: "601564727479",
  appId: "1:601564727479:web:75383afd9b0139633d6532",
  measurementId: "G-9RD48TXYS9",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);

if (process.env.NODE_ENV === "development") {
  console.log("In dev mode");
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export const sendMail = httpsCallable<RequestData, ResponseData>(functions, "sendMail");
